import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ai-correction-modal-mask" }
const _hoisted_2 = { class: "ai-correction-modal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ai-correction-modal-pic" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/static/image/popup_ai.svg" })
], -1)
const _hoisted_4 = { class: "ai-correction-modal-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ai-correction-modal-title" }, "AI校正ツール", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("AI校正ツールでご入力いただいたデータは、サービス品質向上を目的として当社のデータベース上に保存され、データの分析や評価に利用させていただく場合がございます。また、当校正ツールではOpen AIのAPIを利用しています。Open AIの利用規約に関しては"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://openai.com/policies/terms-of-use",
    target: "_blank"
  }, "こちら"),
  /*#__PURE__*/_createTextVNode("をご確認ください。")
], -1)
const _hoisted_7 = { class: "remaining-ai-correction-count" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("本日の残り利用可能回数:")
const _hoisted_9 = { class: "ai-correction-modal-submit" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_ctx.remainingProofreaderCount) + "回", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "disable-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }, "キャンセル"),
        _createElementVNode("button", {
          class: "submit-button",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit())),
          disabled: _ctx.remainingProofreaderCount <= 0
        }, "AI校正を使う", 8, _hoisted_10)
      ])
    ])
  ]))
}